export default __webpack_public_path__ + "static/media/spring-sing.87e6a79a.png";